export const PHASE = {
  AWAITING_START: 'awaiting_start',
  AWAITING_SUBSIDY_REVEAL: 'awaiting_subsidy_reveal',
  BUILDING: 'building',
  AWAITING_VARIABLE_ROLLS: 'awaiting_variable_rolls',
  AWAITING_DISASTER: 'awaiting_disaster',
  RESOLVING: 'resolving',
  BETWEEN_YEARS: 'between_years',
  COP30: 'cop30',
  GAME_OVER: 'game_over'
};
